// extracted by mini-css-extract-plugin
export default {"navBar":"header_navBar__Z8rhx","langContainer":"header_langContainer__kLNp4","headerTitle":"header_headerTitle__rUThP","dropdownContainer":"header_dropdownContainer__iZAlx"};